import React, { useEffect, useState } from 'react';
import { extractTokenFromUrl } from '../utils/redirectHelper';
import './Callback.css';

const Callback = () => {
  const [status, setStatus] = useState('processing');

  useEffect(() => {
    const handleCallback = () => {
      const token = extractTokenFromUrl();
      
      if (token) {
        // Store token
        localStorage.setItem('kit19_sso_token', token);
        setStatus('success');
        
        // Close window if it was a popup
        if (window.opener) {
          window.close();
        } else {
          // Redirect to home or show success message
          setTimeout(() => {
            window.location.href = '/';
          }, 2000);
        }
      } else {
        setStatus('error');
      }
    };

    handleCallback();
  }, []);

  return (
    <div className="callback-container">
      <div className="callback-card">
        {status === 'processing' && (
          <>
            <div className="spinner"></div>
            <h2>Processing authentication...</h2>
            <p>Please wait</p>
          </>
        )}
        
        {status === 'success' && (
          <>
            <div className="success-icon">✓</div>
            <h2>Authentication successful!</h2>
            <p>Redirecting...</p>
          </>
        )}
        
        {status === 'error' && (
          <>
            <div className="error-icon">✗</div>
            <h2>Authentication failed</h2>
            <p>Please try again</p>
          </>
        )}
      </div>
    </div>
  );
};

export default Callback;
